export const PageRouter = [
  // {
  //   url: "/products",
  //   title: "상품구매",
  // },
  {
    url: "/customizing/customizing-products",
    title: "맞춤제작",
    sub: [
      {
        url: "/customizing/customizing-products",
        title: "맞춤제작",
      },
      {
        url: "/customizing/portfolio/노테이프박스",
        title: "포트폴리오",
      },
      {
        url: "/partners",
        title: "고객사",
      },
    ],
  },
  {
    url: "/customizing/print",
    title: "소량인쇄",
    sub: [
      {
        url: "/customizing/print",
        title: "서비스 소개",
      },
      {
        url: "/customizing/print/guide",
        title: "가이드",
      },
      // {
      //   url: "/customizing/print/materials",
      //   title: "재질",
      // },
      // {
      //   url: "/customizing/print/sizes",
      //   title: "사이즈",
      // },
      // {
      //   url: "/customizing/print/requirements",
      //   title: "필수사항",
      // },
      {
        url: "/customizing/print/faq",
        title: "소량인쇄 FAQ",
      },
      {
        url: "/customizing/print/product",
        title: "상품소개",
      },
      {
        url: "/customizing/print/quote",
        title: "견적요청",
      },
      //   {
      //   url: "/edu",
      //   title: "적정포장 무료교육",
      // },
    ],
  },
  {
    url: "/customizing/prototype",
    title: "시제품제작",
  },
  {
    url: "/customizing/promotion",
    title: "판촉물제작",
  },
  {
    url: "/event",
    title: "이벤트",
  },
  {
    url: "/group-purchase",
    title: "공동구매",
  },
  {
    url: "/customizing/design-service",
    title: "디자인 서비스",
  },
  {
    url: "/esg-guide",
    title: "ESG자료실",
    sub: [
      {
        url: "/esg-guide",
        title: "ESG",
      },
      {
        url: "/esg-guide/certification",
        title: "포장재 인증정보",
      },
      {
        url: "/esg-guide/news",
        title: "ESG 환경뉴스",
      },
      {
        url: "/esg-guide/letter",
        title: "ESG 뉴스레터",
      },
      {
        url: "/esg-guide/blog/package",
        title: "소재와 포장재",
      },
      {
        url: "/esg-guide/blog/make",
        title: "제작사례 & 포장재리뷰",
      },
    ],
  },
  {
    url: "/csboard/notice",
    title: "고객지원",
    sub: [
      {
        url: "/csboard/notice",
        title: "공지사항",
      },
      {
        url: "/csboard/faq",
        title: "FAQ",
      },
      {
        url: "/csboard/library",
        title: "자료 다운로드",
      },
      {
        url: "/csboard/contact",
        title: "제휴문의",
      },
      {
        url: "/csboard/b2b",
        title: "패키징 제안받기",
      },
      {
        url: "/csboard/service",
        title: "구해드립니다",
      },
    ],
  },
];
